import MessageModal from './MessageModal';

export default MessageModal;



// WEBPACK FOOTER //
// ./src/components/MessageModal/index.js